import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SafeIcon from '../../common/SafeIcon';

export default function Layout() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await logout();
    navigate('/auth');
  };

  const navItemClass = (path) => 
    `flex flex-col items-center p-2 text-xs font-medium transition-colors ${
      location.pathname === path ? 'text-indigo-600' : 'text-gray-500 hover:text-gray-900'
    }`;

  return (
    <div className="min-h-screen bg-gray-50 pb-20 md:pb-0">
      <nav className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-40 hidden md:block">
        <div className="max-w-4xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="font-bold text-xl flex items-center space-x-2 text-indigo-600">
            <div className="bg-indigo-100 p-1.5 rounded-lg">
              <SafeIcon icon="DollarSign" className="w-5 h-5" />
            </div>
            <span>KidCash</span>
            <span className="text-[10px] bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded-full font-bold uppercase tracking-wider ml-1">v1.2</span>
          </Link>
          
          <div className="flex items-center space-x-6">
            <Link to="/" className="text-sm font-medium text-gray-600 hover:text-indigo-600">Dashboard</Link>
            <Link to="/settings" className="text-sm font-medium text-gray-600 hover:text-indigo-600">Settings</Link>
            <button onClick={handleLogout} className="text-sm font-medium text-red-600 hover:text-red-700">Logout</button>
          </div>
        </div>
      </nav>

      <main className="p-4 max-w-4xl mx-auto">
        <Outlet />
      </main>

      {/* Mobile Bottom Nav */}
      <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around items-center h-16 pb-safe z-40">
        <Link to="/" className={navItemClass('/')}>
          <SafeIcon icon="Home" className="w-6 h-6 mb-1" />
          <span>Home</span>
        </Link>
        <Link to="/settings" className={navItemClass('/settings')}>
          <SafeIcon icon="Settings" className="w-6 h-6 mb-1" />
          <span>Settings</span>
        </Link>
        <button onClick={handleLogout} className="flex flex-col items-center p-2 text-xs font-medium text-gray-500 hover:text-red-600">
          <SafeIcon icon="LogOut" className="w-6 h-6 mb-1" />
          <span>Logout</span>
        </button>
      </nav>
    </div>
  );
}